module.exports = __webpack_public_path__ + "static/media/camera-lens-cap1.39b6092e.aac";